import {
    SubmitButtonProps,
    CancelButtonProps,
    MyItemNotListedButtonProps,
    ClearItemsButtonProps,
} from "./PopconfirmButtonTypeHelper";
import PopconfirmButton from "./PopconfirmButton";

export const SubmitButtonWithPopconfirm = (
    props: SubmitButtonProps
): JSX.Element => (
    <PopconfirmButton
        {...props}
        label="Submit Items"
        confirmText="Yes, Submit"
        cancelText="Cancel"
        popconfirmTitleLines={[
            {
                textId: "submit-line-1",
                text: "Are you sure you are ready to submit?",
            },
        ]}
        id="submit"
        overlayClassName="submit-popconfirm-popover"
        type="primary"
    />
);

export const CancelButtonWithPopconfirm = (
    props: CancelButtonProps
): JSX.Element => (
    <PopconfirmButton
        {...props}
        label="Cancel"
        confirmText="Yes, Cancel"
        cancelText="No, Keep Items"
        popconfirmTitleLines={[
            {
                textId: "cancel-line-1",
                text: "Are you sure you want to cancel this resolution request?",
            },
        ]}
        id="cancel"
        overlayClassName="cancel-popconfirm-popover"
    />
);

export const MyItemIsNotListedButtonWithPopconfirm = (
    props: MyItemNotListedButtonProps
): JSX.Element => (
    <PopconfirmButton
        {...props}
        label="My Item Is Not Listed"
        confirmText="Yes"
        cancelText="No"
        popconfirmTitleLines={[
            {
                textId: "item-not-listed-line-1",
                text: "Are you sure you want to report that your item is not listed?",
            },
        ]}
        id="my-item-is-not-listed"
        overlayClassName="my-item-is-not-listed-popconfirm-popover"
    />
);

export const ClearItemsButtonWithPopconfirm = (
    props: ClearItemsButtonProps
): JSX.Element => {
    const { ...restProps } = props;
    return (
        <PopconfirmButton
            {...restProps}
            label="Clear Selected Items"
            confirmText="Yes, Clear Items"
            cancelText="No, Keep Items"
            popconfirmTitleLines={[
                {
                    textId: "clear-items-line-1",
                    text: "Are you sure you want to start over?",
                },
                {
                    textId: "clear-items-line-2",
                    text: "Items selected will be cleared.",
                },
            ]}
            id="clear-items"
            overlayClassName="clear-items-popconfirm-popover"
        />
    );
};
